import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/feature/Breadcrumb";

const entries = [
  {
    title: "Notes from the Studio",
    date: "January 2026",
    meta: "Craft",
    desc: "A quiet morning at the bench with our lead jeweler, on why the same ring is finished twice.",
    img: "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20jeweler%20at%20a%20wooden%20workbench%20polishing%20a%20small%20gold%20ring%2C%20warm%20natural%20window%20light%2C%20muted%20neutral%20interior%2C%20quiet%20contemporary%20jewelry%20atelier%2C%20refined%20editorial%20photography&width=500&height=625&seq=aurelin-journal-editorial-01&orientation=portrait",
  },
  {
    title: "The Language of Gold",
    date: "December 2025",
    meta: "Material",
    desc: "Why we work only in solid recycled 18k gold, and what tonal difference it makes worn against skin.",
    img: "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20woman%20wearing%20a%20delicate%20gold%20necklace%20layered%20over%20a%20cream%20knit%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20studio%20backdrop%2C%20refined%20contemporary%20jewelry%20campaign%20photography&width=500&height=625&seq=aurelin-journal-editorial-02&orientation=portrait",
  },
  {
    title: "Worn With Ease",
    date: "November 2025",
    meta: "Worn",
    desc: "Three quiet ways to layer the Everyday Metal collection, photographed in natural winter light.",
    img: "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20woman%20wearing%20simple%20gold%20hoop%20earrings%20and%20a%20thin%20ring%2C%20soft%20natural%20light%2C%20warm%20neutral%20studio%20backdrop%2C%20refined%20contemporary%20jewelry%20campaign%20photography%2C%20quiet%20luxury%20aesthetic&width=500&height=625&seq=aurelin-journal-editorial-03&orientation=portrait",
  },
];

export default function Journal() {
  return (
    <Layout>
      <section>
        <div className="shell pt-24">
          <Breadcrumb items={[{ label: "Journal" }]} />
          <h1 className="font-display text-5xl md:text-6xl text-black mt-8">Journal</h1>
          <p className="mt-6 text-[15px] text-graphite max-w-xl leading-relaxed">
            Slow notes from the Antwerp atelier — on material, craft and the pieces we wear.
          </p>
        </div>

        <div className="shell py-24">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-16">
            {entries.map((e) => (
              <article key={e.title}>
                <div className="w-full aspect-[4/5] overflow-hidden bg-stone">
                  <img src={e.img} alt={e.title} title={`${e.title} — Aurelin journal`} className="w-full h-full object-cover object-top" />
                </div>
                <p className="mt-6 eyebrow">{e.date} · {e.meta}</p>
                <h3 className="mt-3 font-display text-2xl text-black">{e.title}</h3>
                <p className="mt-3 text-[14px] text-graphite leading-[1.8]">{e.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}